var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 15px;\n  flex-direction: column;\n  flex: 1;\n"], ["\n  display: flex;\n  gap: 15px;\n  flex-direction: column;\n  flex: 1;\n"])));
var templateObject_1;
//# sourceMappingURL=FilteringAndSorting.Styles.js.map